import moment from "moment";

export function isDateValid(value) {
    if (value.length === 10) {
        const date = moment(value, "DD.MM.YYYY");
        
        if (date.isValid()) return true;
    }
    return false;
}
